import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./firebase";

export const CONSTANTS = { ADDRESS_SEPERATOR: ";" };

createApp(App).use(store).use(router).mount("#app");
